import styled from 'styled-components';

const LeftBarStyle = styled.aside`
	--leftBarMaxWidth: calc((100% / 8) * 2 + var(--gutter));
	--categoryNameMarginRight: var(--sp1x);
	--filterItemWrapMarginBottom: var(--sp4x);
	--filterTitleWrapMarginBottom: var(--sp3x);
	--innerContentItemMarginTop: var(--sp2x);

	width: var(--leftBarMaxWidth);
	margin-right: var(--gutter);

	.filter-item-wrap {
		margin-bottom: var(--filterItemWrapMarginBottom);

		.filter-title-wrap {
			display: flex;
			align-items: center;
			margin-bottom: var(--filterTitleWrapMarginBottom);
		}

		.inner-content {
			overflow: hidden;
		}
	}

	.cat-name-block {
		margin-right: var(--categoryNameMarginRight);
	}

	.cat-child-name-block {
		display: block;
		width: fit-content;
		transition: color 0.3s ease-out;

		&:not(:first-child) {
			margin-top: var(--innerContentItemMarginTop);
		}

		@media (hover: hover) {
			&:hover {
				color: var(--coral);
			}
		}

		&.active {
			color: var(--green);
		}
	}

	.icon-arrow {
		transition: transform var(--trTime) ease-out;

		&.active {
			transform: rotate(180deg);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--leftBarMaxWidth: calc((100% / 8) * 2);
		--filterItemWrapMarginBottom: var(--sp2x);
		--filterTitleWrapMarginBottom: var(--sp2x);
		--innerContentItemMarginTop: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--leftBarMaxWidth: calc((100% / 8) * 2);
		--filterItemWrapMarginBottom: var(--sp2x);
		--filterTitleWrapMarginBottom: var(--sp2x);
		--innerContentItemMarginTop: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--leftBarMaxWidth: calc((100% / 8) * 2);
		--filterItemWrapMarginBottom: var(--sp3x);
		--filterTitleWrapMarginBottom: var(--sp2x);
		--innerContentItemMarginTop: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		display: none;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		display: none;
	}
`;

export default LeftBarStyle;
